import { Box } from "../Box";

export const Flex = Box;
